export const AccountRefreshType = {
  fix: 'fix',
  refresh: 'refresh',
  manualRefresh: 'manual-refresh',
};
